import { Graph } from "./Graph";
import { PriorityQueue } from "../Util";

export class AStarSearch<T> {

    private heuristic: (a: T, b: T) => number;
    private graph: Graph<T>;

    constructor(graph: Graph<T>, heuristic: (a: T, b: T) => number) {
        this.graph = graph;
        this.heuristic = heuristic;
    }

    public search(start: T, goal: T) {
        if (!start) throw Error('start node must be set');
        if (!goal) throw Error('goal node must be set');

        let mapCameFrom = new Map<T, T>();
        let mapCostsSoFar = new Map<T, number>();

        mapCameFrom.set(start, start);
        mapCostsSoFar.set(start, 0);

        let frontier = new PriorityQueue<T>(false);
        frontier.enqueue(start, 0);

        let solved = false;

        while (!frontier.isEmpty) {
            let current = frontier.dequeue();

            if (current === goal) {
                solved = true;
                break;
            }

            let neighbours = this.graph.getNeighbours(current);

            for (let next of neighbours) {
                let newCost = mapCostsSoFar.get(current) + this.graph.getCost(current, next);

                if (!mapCostsSoFar.has(next) || newCost < mapCostsSoFar.get(next)) {
                    mapCostsSoFar.set(next, newCost);

                    let priority = newCost;
                    if (this.heuristic) {
                        priority += this.heuristic(next, goal); // Are we moving somewhat in the right direction?
                    }
                    frontier.enqueue(next, priority);

                    mapCameFrom.set(next, current);
                }
            }
        }

        return {
            cameFrom: mapCameFrom,
            solved: solved
        };
    }

}
